import recovery from "@/store/app/entraId/recovery/recovery";
import objects from "@/store/app/entraId/objects";
import seats from "@/store/app/entraId/seats";
import stats from "@/store/app/entraId/stats";
import report from "@/store/app/entraId/report";
import userReport from "@/store/app/entraId/userReport";
import backups from "@/store/app/entraId/backups";
import jobs from "@/store/app/entraId/jobs";
import editDomain from "@/store/app/entraId/editDomain";
import allEventLogs from "@/store/app/entraId/activity-logs/allEventLogs";
import webActivityLogs from "@/store/app/entraId/activity-logs/webActivityLogs";
import backedUpItems from "@/store/app/entraId/activity-logs/backedUpItems";
import backupsByDay from "@/store/app/entraId/activity-logs/backupEventsByDay";
import backupItems from "@/store/app/entraId/activity-logs/backupItems";
import settings from "@/store/app/entraId/settings";
import connectionSettings from "@/store/app/entraId/settings/connectionSettings";

export default {
  namespaced: true,

  actions: {},

  modules: {
    recovery,
    objects,
    seats,
    stats,
    report,
    userReport,
    backups,
    jobs,
    editDomain,
    allEventLogs,
    webActivityLogs,
    backedUpItems,
    backupsByDay,
    backupItems,
    settings,
    connectionSettings,
  }
}
